import { trpc } from '@/shared/api';

/** 상품에 허용된 폰트·잉크(editor.textOptions.listForProduct, 공개). 비어 있으면 텍스트 추가를 막는다(U5). */
export const useProductTextOptionsQuery = (productId: string) =>
  trpc.editor.textOptions.listForProduct.useQuery(
    { productId },
    { enabled: productId.length > 0, retry: false },
  );
